import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    instructors: [],
    employees: [],
  },
  getters: {
    instructors: state => state.instructors,
    employees: state => state.employees,
  },
  mutations: {
    SET_INSTRUCTORS: (state, data) => { state.instructors = data },
    SET_EMPLOYEES: (state, data) => { state.employees = data },
  },
  actions: {
    async createResearchInstructor({ commit }, params) {
      try {
        const response = await axios.post('uni/researchInstructors', params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getResearchInstructors({ commit }, params) {
      try {
        const response = await axios.get('uni/researchInstructors', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          commit('SET_INSTRUCTORS', records)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async deleteResearchInstructor({ commit }, id) {
      try {
        const response = await axios.delete(`uni/researchInstructors/${id}`)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getEmployeesByOrganizationId({ commit }) {
      try {
        const response = await axios.get('uni/employees/getAllByOrganizationId')
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_EMPLOYEES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
